import '@babel/polyfill'
import './mock'
import './style.scss'
import Vue from 'vue'
import request from 'common/utils/request'
import Share from 'common/js/share'
import storejs from 'store'
import {
  Toast,
  Popup,
  Icon,
  Checkbox,
  Picker
} from 'vant'
import receiveCoupon from '../components/receive-coupon'
import dayjs from 'dayjs'
const {
  vars,
  shareData
} = require('./config')
import fundebug from 'fundebug-javascript'
import fundebugVue from 'fundebug-vue'
Vue.config.productionTip = false
Vue.use(vars)
Vue.use(request, {
  endTime: '2020/12/31'
})
// eslint-disable-next-line
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(Picker)
Vue.prototype.$loading = () => {
  return Toast.loading({
    message: 'Loading...',
    duration: 0,
    forbidClick: true
  })
}
Vue.prototype.$loading.clear = () => {
  return Toast.clear()
}

new Share(shareData)
Vue.use(receiveCoupon)
Vue.prototype.$storejs = storejs
Vue.prototype.$dayjs = dayjs

if (process.env.VUE_APP_ENV !== 'dev') {
  fundebug.apikey = '7c3f418b6319a3c8a15ebf8b209305e3993ea5e0b3c402e37758edc233434696'
  fundebug.filters = [{
    type: /^unhandledrejection$/
  }]
  fundebug.silentResource = true
  fundebugVue(fundebug, Vue)
}

if (process.env.VUE_APP_ENV !== 'prod') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line
  new VConsole()
} else {
  const AlloyLever = require('alloylever')
  AlloyLever.config({
    cdn: 'https://at-cdn.pangku.com/static/cdn/vconsole.min.js'
  })
}
